import API from "./api";

const customerProviderService = {
  // ==========================================
  // Get Provider Details
  // ==========================================

  getProvider(providerId) {
    return API.get(
      `/customer/provider/${providerId}`
    );
  },
};

export default customerProviderService;